import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

const LINKS = [
  { label: "Home", to: "/" },
  { label: "Our Builds", to: "/our-builds" },
  { label: "Our Plans", to: "/our-plans" },
  { label: "About", to: "/about" },
  { label: "Meet the Team", to: "/team" },
  { label: "Careers", to: "/careers" },
  { label: "Contact", to: "/contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <header data-testid="site-header" className="fixed top-0 inset-x-0 z-50 bg-black/90 backdrop-blur-md border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-3 flex items-center justify-between">
          <Link to="/" data-testid="nav-logo" aria-label="LW&Co home">
            <img src="/images/logo.png" alt="LW&Co Building Company" className="w-[150px] md:w-[205px] h-auto" />
          </Link>
          <nav className="hidden lg:flex items-center gap-7">
            {LINKS.map((l) => (
              <NavLink key={l.to} to={l.to} data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                className={({ isActive }) =>
                  `text-[13px] font-medium uppercase tracking-[0.18em] transition-colors duration-300 ${isActive ? "text-gold" : "text-white/70 hover:text-gold"}`}>
                {l.label}
              </NavLink>
            ))}
            <Link to="/contact" data-testid="nav-enquire-btn"
              className="ml-2 px-6 py-2.5 bg-gold text-black text-[13px] font-bold uppercase tracking-[0.15em] hover:bg-white transition-colors duration-300">
              Enquire
            </Link>
          </nav>
          <button data-testid="nav-mobile-toggle" onClick={() => setOpen(true)} className="lg:hidden text-white" aria-label="Open menu">
            <Menu size={24} />
          </button>
        </div>
      </header>
      <AnimatePresence>
        {open && (
          <motion.div data-testid="mobile-menu" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            className="fixed inset-0 z-[60] bg-black flex flex-col">
            <div className="h-20 px-6 flex items-center justify-between border-b border-white/10">
              <img src="/images/logo.png" alt="LW&Co Building Company" className="w-[130px] h-auto" />
              <button data-testid="mobile-menu-close" onClick={() => setOpen(false)} className="text-white" aria-label="Close menu">
                <X size={24} />
              </button>
            </div>
            <div className="flex-1 flex flex-col justify-center px-8 gap-2">
              {LINKS.map((l, i) => (
                <motion.div key={l.to} initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.07 * i }}>
                  <Link to={l.to} data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s/g, "-")}`} onClick={() => setOpen(false)}
                    className="block py-3 font-display font-semibold uppercase text-4xl text-white/85 hover:text-gold transition-colors">
                    {l.label}
                  </Link>
                </motion.div>
              ))}
              <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.35 }}>
                <Link to="/contact" data-testid="mobile-enquire-btn" onClick={() => setOpen(false)}
                  className="mt-8 inline-block px-8 py-3.5 bg-gold text-black font-bold text-sm uppercase tracking-[0.15em]">
                  Enquire Now
                </Link>
              </motion.div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
